require('./detailCharityCard.scss');

const PropTypes = require('prop-types');
const React = require('react');
const { FormattedText, getLanguage } = require('core/i18n').i18n;

// @api
import apiURLBuilder from 'core/apiURLBuilder';
import { APIGet } from 'utilities/APIRequestHelper';

const { getPlainAmountObject, formatAmountObject } = require('utilities/currencyHelper');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

const { EURO_TEXT } = require('constants/index');
const language = getLanguage();


class DetailCharityCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contributedAmount: 0,
            error: false
        };
    }

    componentWillMount() {
        const baseURL = apiURLBuilder.getURL('cardsSolidarityContributionAmount');
        const { immCard } = this.props;
        const numContract = immCard.get('fullContractNumber').replace(/ /g,'');
        const pan = immCard.get('number').replace(/ /g,'');

        APIGet(() => {}, `${baseURL}?numeroContrato=${numContract}&numeroTarjeta=${pan}`)
            .then(response => {
                this.setState({
                    contributedAmount: response.contributedAmount
                })
            })
            .catch(() => {
                this.setState({
                    error: true
                })
            });
    }

    buildAmount = () => {
        const amountObject = {
            amount: this.state.contributedAmount,
            currency: this.props.immCard.getIn(['availableBalance', 'currency']) || EURO_TEXT
        };
        const plainAmountObject = getPlainAmountObject(amountObject);

        if(!this.state.error) {
            return (
                <span className="detail-charity-card__title detail-charity-card--important">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </span>
            )
        } else {
            return (
                <span className="detail-charity-card__title detail-charity-card--important">-</span>
            )
        }
    }

    render() {
        const { isSolidarity } = this.props;
        const amount = this.buildAmount();

        return (
            <div className="detail-charity-card">
                <div className="detail-charity-card__section">
                    {isSolidarity &&
                        <div className="detail-charity-card__available-balance">
                            {amount}
                            <span className="detail-charity-card__subtitle">
                                <FormattedText value="cardCharityDetail-monthBalance" />
                            </span>
                        </div>
                    }
                </div>
                {/*<div className="detail-charity-card__section">
                    <div className="detail-charity-card__available-balance">
                        <span className="detail-charity-card__title detail-charity-card--important">
                            24€
                        </span>
                        <span className="account-header-details__subtitle">
                            <FormattedText value="cardCharityDetail-totalBalance" />
                        </span>
                    </div>
                </div>*/}
            </div>
        );
    }
}

DetailCharityCard.propTypes = {
    immCard: PropTypes.function,
    isSolidarity: PropTypes.bool
};

module.exports = DetailCharityCard;
